import gsap from "gsap";
import ScrollTriggerController from "./scroll-trigger_controller";

export default class ZoomController extends ScrollTriggerController {

    static values = {
        scale:    { type: Number, default: 1.2 },
        yPercent: { type: Number, default: -10 },
        scrub:    { type: Number, default: 1 },
        start:    { type: String, default: 'top bottom' },
        end:      { type: String, default: 'bottom end' },
        ease:     { type: String, default: 'none' },
        pin:      { type: Boolean, default: false },
    };

    static targets = [
        'image',
    ];

    get image() {
        return this.imageTarget;
    }

    timeline;

    connect() {
        this.timeline = gsap.timeline({
            scrollTrigger: {
                trigger: this.element,
                start:   this.startValue,
                end:     this.endValue,
                scrub:   this.scrubValue,
                pin:     this.pinValue
            },
        });

        this.timeline.from(this.image, {
            scale:    this.scaleValue,
            yPercent: this.yPercentValue,
            ease:     this.easeValue,
        }, 0);
    }

    disconnect() {
        this.timeline?.kill();
        this.timeline = null;
    }
}
